import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
  selectOrganizationId,
  selectUserEmail,
  selectUserName,
} from 'state/User/userSlice';

const useLaunchDarkly = (): boolean => {
  const [isLaunchDarklyInitialized, setIsLaunchDarklyInitialized] =
    useState<boolean>(false);

  const organizationId = useSelector(selectOrganizationId);
  const currentUserName = useSelector(selectUserName);
  const currentUserEmail = useSelector(selectUserEmail);
  const ldClient = useLDClient();

  useEffect(() => {
    const identifyUser = async () => {
      if (
        currentUserEmail &&
        currentUserName &&
        organizationId &&
        ldClient &&
        !isLaunchDarklyInitialized
      ) {
        await ldClient.identify({
          kind: 'user',
          key: currentUserEmail,
          name: currentUserName,
          accountId: organizationId,
        });
        setIsLaunchDarklyInitialized(true);
      }
    };

    identifyUser();
  }, [
    currentUserEmail,
    currentUserName,
    organizationId,
    ldClient,
    isLaunchDarklyInitialized,
  ]);

  return isLaunchDarklyInitialized;
};

export default useLaunchDarkly;
